var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-3\n    p-4 gap-2"},_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.id},[_c('router-link',{attrs:{"to":("/photos/" + (photo.id))}},[_c('img',{staticClass:"object-fit sm:h-64 sm:w-64 h-32 w-32",attrs:{"src":photo.url}})])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328b079c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gallery/Container.vue
// module id = null
// module chunks = 